exports.load = function() {
  var module = angular.module('bbl.authorization', [
        'bbl.services'
      ]);

  require('./authorization-style.less');
  require('./authorization-directives').inject(module);
  require('./signup-controller').inject(module);
  require('./login-controller').inject(module);
  require('./change-password-key-controller').inject(module);
  require('./forgot-password-controller').inject(module);
  require('./logout-controller').inject(module);
  require('./password-controller').inject(module);

  require('./google-login-btn');
};



/*****************
 ** WEBPACK FOOTER
 ** ./app/authorization/index.js
 ** module id = 293
 ** module chunks = 0
 **/